import vue from "vue";

export default {
    SET_CURRENCY_ID: (state, currencyId) => {
        state.currencyId = currencyId;
    },
    SET_TAX_RATE_FOR_DOCTORS: (state, taxRateForDoctors) => {
        state.taxRateForDoctors = taxRateForDoctors;
    },
    SET_CONFIG_TO_EDIT: (state, configsToEdit) => {
        state.configsToEdit = configsToEdit;
    },
    // SET_ACCOUNTING:(state,payload)=>{
    //     state.accounting = payload;
    // }
    // SET_ACCOUNTS_RECEIVABLE_PERSONALS: (state, value) => {
    //     state.accounting.accountsReceivablePersonals = value;
    // },
    // SET_CLINIC_SERVICE_INCOME: (state, value) => {
    //     state.accounting.clinicServiceIncome = value;
    // },
    // SET_DISCOUNT: (state, value) => {
    //     state.accounting.discount = value;
    // },
    // SET_COMMERCIAL_PAYMENTS_ACCOUNTS_DOCTOR: (state, value) => {
    //     state.accounting.commercialPaymentsAccountsDoctors = value;
    // },
    // SET_ORGANIZATION_OF_TAX_DOCTORS_TAX: (state, value) => {
    //     state.accounting.organizationOfTaxDoctorsTax = value;
    // },




}